//
// Sticky navigation
//
$(document).ready(function(){   
    var stickyBar = $('header .desctop .sticky');
    if(stickyBar.length == 0) return;
   
    var spaceBar = $('header .desctop');
    
    $('.headerImage').on('load', function(){
        var barHeight = spaceBar.height();

        // Lock bar height
        spaceBar.height(barHeight);        

        $(window).scroll(function(){ 
            if($(window).scrollTop() > barHeight) {
                stickyBar.addClass('stick');
            }
            else {
                stickyBar.removeClass('stick');
            }
        });
    });     

});
